import React from 'react'

import Poster from '../Poster/Poster'
import About from '../About/About'
import Provide from '../Provide/Provide'
import Count from '../Count/Count'
import Started from '../Started/Started'
import Feedback from '../Feedback/Feedback'
import Video from '../Video/Video'
import Testimonial from '../Testimonial/Testimonial'
import Partner from '../Partner/Partner'

const Home = () => {
  return (
    <>
        <Poster/>
        <About/>
        <Provide/>
        <Video/>
        <Count/>
        <Started/>
        <Partner/>
<Testimonial/>
       
    </>
  )
}

export default Home